// SalesAnalytics.jsx
import React from "react";

const SalesAnalytics = () => {
  const statuses = ["PENDING", "PAID", "FAILED"];
  const colors = {
    PENDING: "bg-yellow-100 text-yellow-800",
    PAID: "bg-green-100 text-green-800",
    FAILED: "bg-red-100 text-red-800",
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Sales Status Overview</h2>
      <ul className="space-y-3">
        {statuses.map((status) => (
          <li
            key={status}
            className={`${colors[status]} px-4 py-2 rounded-md shadow-sm font-medium`}
          >
            {status}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SalesAnalytics;
